"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ola = _interopRequireDefault(require("ola"));

var _ = _interopRequireDefault(require("."));

var _excluded = ["olaTime"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var LottieAnimationWithMousePosition = function LottieAnimationWithMousePosition(_ref) {
  var olaTime = _ref.olaTime,
      props = _objectWithoutProperties(_ref, _excluded); // Create our own ref that we pass to the component so that we can use lottie functions.


  var ref = (0, _react.useRef)(null); // Create an Ola instance for frame interpolation.

  var interpolatedFrame = (0, _ola.default)(0, olaTime);
  /*
  * Follow mouse position for animation on Mouse move.
  */

  var onMouseMove = function onMouseMove(e) {
    if (ref && ref.current) {
      // Determine the mouse position relative to the current Lottie.
      var clientRect = ref.current.wrapper.getBoundingClientRect();
      var mousePositionRelative = e.type === 'touchmove' ? (e.touches[0].clientX - clientRect.left) / clientRect.width : (e.clientX - clientRect.left) / clientRect.width;
      var lottiePosition = Math.max(0, Math.min(1, mousePositionRelative)); // Round the frame, clamp it, and pass it to Ola for frame interpolation.

      var rawFrame = Math.round(ref.current.totalFrames * lottiePosition);
      var frame = Math.min(ref.current.totalFrames - 1, Math.max(1, rawFrame));
      interpolatedFrame.set(frame); // Go to the frame we just calculated using the Ola value.

      ref.current.goToAndStop(interpolatedFrame.value, true);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    onMouseMove: onMouseMove,
    onTouchMove: onMouseMove
  }, /*#__PURE__*/_react.default.createElement(_.default, _extends({
    ref: ref
  }, props)));
};

var _default = LottieAnimationWithMousePosition;
exports.default = _default;